<template>
  <div id="battle_stadium_tab" class="margin-subpages">
    <div class="pt-32 px-20 pb-24 chart-container">
      <div class="sub-title px-12">
        <span class="fs-24">{{
          $utils("addCommasInNumber", missionEntry)
        }}</span>
        {{ $t("happilyVillage.Entries") }}
      </div>
      <div class="relative" style="height: 340px">
        <div
          class="center absolute-mid"
          v-if="loadingChartStatus"
        >
          <loading-even></loading-even>
        </div>
        <canvas
          ref="missionBarchart"
          height="340px"
          class="barchart-style"
        ></canvas>
      </div>
    </div>
    <div class="mt-8">
      <div class="sub-title mt-8">
        <span class="fs-24">{{
          $utils("addCommasInNumber", countMissionAll)
        }}</span>
        {{ $t("happilyVillage.Mission") }}
      </div>
      <div class="flex-row-between mt-14">
        <div class="relative flex">
          <el-input
            class="input-style"
            style="height: 40px"
            autosize
            :placeholder="$t('happilyVillage.Select')"
            v-model="inputSearchMission"
            clearable
          ></el-input>
          <div class="select-gray ml-16">
            <el-select
              v-model="sortingBy"
              :placeholder="$t('happilyVillage.Select')"
              @change="onChangeSorting($event)"
            >
              <el-option
                v-for="item in sortOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-center">
          <el-button
            class="btn-add small"
            size="small"
            icon="el-icon-plus"
            @click="createMissionModal = true"
            >{{ $t("happilyVillage.add_mission") }}</el-button
          >
        </div>
      </div>
      <div>
        <div class="flex fw-800 fs-14 mt-18 mb-24 px-24">
          <div class="col-1">{{ $t("happilyVillage.Order") }}</div>
          <div class="col-2 pl-8 pr-10">
            {{ $t("happilyVillage.Mission_Name_and") }}
          </div>
          <div class="col-4 opa-08">{{ $t("happilyVillage.Entries") }}</div>
          <div class="col-5 opa-08">{{ $t("happilyVillage.Winner") }}</div>
          <div class="col-6 opa-08 center">
            {{ $t("happilyVillage.Status") }}
          </div>
        </div>
        <div v-if="loadingMissionList">
          <div v-for="item in ['st-1', 'st-2', 'st-3']" :key="item">
            <div class="mission-list flex">
              <div class="col-1">
                <div class="flex-mid">
                  <div class="opa-02">
                    <img
                      src="../../assets/images/happilyvillage/ic_more@2x.png"
                      style="height: 20px"
                    />
                    <img
                      src="../../assets/images/happilyvillage/ic_more@2x.png"
                      style="height: 20px; margin-left: -15px"
                    />
                  </div>
                  <div class="image image-profile-32 text-skeleton"></div>
                </div>
              </div>
              <div class="col-2 pl-8 pt-4 pr-10">
                <div
                  style="width: 140px; height: 24px"
                  class="bd-r-3 mb-4 text-skeleton"
                ></div>
              </div>
              <div class="col-3 pr-14 pt-4">
                <div
                  style="width: 180px; height: 24px"
                  class="bd-r-3 mb-4 text-skeleton"
                ></div>
              </div>
              <div v-if="item !== 'st-3'" class="col-4 pt-4">
                <div
                  style="width: 60px; height: 24px"
                  class="bd-r-3 mb-4 text-skeleton"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(item, index) in missionList" :key="item.id">
          <div
            v-if="
              item.status == 'completed' ||
              item.checkLive
            "
            class="mission-list flex"
            @click="showMissionDetails(item)"
            :style="{ cursor: item.status === 'completed' ? 'pointer' : 'default' }"
          >
            <div class="col-1">
              <div class="flex-center">
                <div class="opa-02 pt-2">
                  <img
                    src="../../assets/images/happilyvillage/ic_more@2x.png"
                    style="height: 26px"
                  />
                  <img
                    src="../../assets/images/happilyvillage/ic_more@2x.png"
                    style="height: 26px; margin-left: -20px"
                  />
                </div>
                <div class="pt-2 fs-14" style="width: 64px">
                  {{ $t("happilyVillage.Week") }} {{ item.week }}
                </div>
              </div>
            </div>
            <div class="col-2 ellipsis pl-8 pr-10 flex-center">
              <img
                v-if="item.type"
                :src="item.missionTypeIcon"
                style="height: 32px"
                class="ml-4 mr-8"
              />
              <div style="width: 350px">
                <div class="ellipsis fw-800">{{ item.name }}</div>
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 300px">
                    {{ item.description }}
                  </div>
                  <div class="ellipsis">
                    {{ item.description }}
                  </div>
                </el-tooltip>
              </div>
            </div>
            <div class="col-4 pt-8">
              {{ $utils("addCommasInNumber", item.entries) }}
              {{ $t("happilyVillage.entries") }}
            </div>
            <div class="col-5 pt-8"
            :class="[ blurMode ?  'blurelement': '' ]">{{ item.winner }}</div>
            <div class="col-6 flex-center">
              <div class="ml-auto flex-center" v-if="item.status === 'skip'">
                <div class="mission-list-btn skip">skip</div>
                <div style="width: 20px"></div>
              </div>
              <div class="ml-auto flex-center" v-else-if="item.checkLive">
                <div class="mission-list-btn live">
                  {{ $t("happilyVillage.Live") }}
                </div>
                <div style="width: 20px"></div>
              </div>
              <div v-else class="ml-auto flex-center">
                <div class="mission-list-btn completed cursor-default">
                  {{ $t("happilyVillage.Completed") }}
                </div>
                <el-tooltip :content="$t('happilyVillage.View_Details', 'View Details')" placement="top">
                  <i class="el-icon-info details-icon ml-8"></i>
                </el-tooltip>
                <div style="width: 12px">&nbsp;</div>
              </div>
              <el-tooltip
                effect="none"
                placement="bottom-end"
                v-if="item.status == 'skip'"
              >
                <div slot="content" class="relative">
                  <div class="hamburger-menu">
                    <div
                      v-if="item.status == 'skip'"
                      @click="unSkipMission(item)"
                      :class="`top`"
                    >
                      {{ $t("happilyVillage.Unskip_Mission") }}
                    </div>
                    <div
                      v-else
                      @click="skipMission(item)"
                      :class="`top${item.status == 'skip' ? ' disable' : ''}`"
                    >
                      {{ $t("happilyVillage.Skip_Mission") }}
                    </div>

                    <div
                      @click="editeMission(item, index)"
                      :class="`bottom${
                        item.type == 'happily' ? ' disable' : ''
                      }`"
                    >
                      {{ $t("happilyVillage.Edit") }}
                    </div>
                    <div
                      @click="deleteMission(item)"
                      :class="`bottom${
                        item.type == 'happily' ? ' disable' : ''
                      }`"
                    >
                      {{ $t("happilyVillage.Delete") }}
                    </div>
                  </div>
                </div>
                <img
                  src="../../assets/images/happilyvillage/ic_more@2x.png"
                  style="height: 20px"
                  class="show-menu"
                />
              </el-tooltip>
            </div>
          </div>
        </div>
        <draggable
          v-model="missionList"
          v-bind="dragOptions"
          :move="chooseRecipe"
          @update="updateCradList"
          :disabled="false"
          class="list-group"
          ghost-class="ghost"
        >
          <div
            class="list-group-item"
            v-for="(item, index) in missionList"
            :key="item.id"
          >
            <div
              v-if="
                item.status !== 'completed' &&
                item.checkLive != true
              "
              class="mission-list flex"
              :style="{ cursor: item.status === 'completed' ? 'pointer' : 'default' }"
              @click="showMissionDetails(item)"
            >
              <div class="col-1">
                <div class="flex-center">
                  <div class="opa-08 pt-2">
                    <img
                      src="../../assets/images/happilyvillage/ic_more@2x.png"
                      style="height: 26px"
                    />
                    <img
                      src="../../assets/images/happilyvillage/ic_more@2x.png"
                      style="height: 26px; margin-left: -20px"
                    />
                  </div>
                  <div class="pt-2 fs-14" style="width: 64px">
                    {{ $t("happilyVillage.Week") }} {{ item.week }}
                  </div>
                </div>
              </div>
              <div class="col-2 ellipsis fw-800 pl-8 pr-10 flex-center">
                <img
                  v-if="item.type"
                  :src="item.missionTypeIcon"
                  style="height: 32px"
                  class="ml-4 mr-8"
                />
                <div style="width: 350px">
                  <div class="ellipsis fw-800">{{ item.name }}</div>
                  <el-tooltip placement="top">
                    <div slot="content" style="max-width: 300px">
                      {{ item.description }}
                    </div>
                    <div class="ellipsis">
                      {{ item.description }}
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <div class="col-4 pt-8">
                {{ $utils("addCommasInNumber", item.entries) }}
                {{ $t("happilyVillage.entries") }}
              </div>
              <div class="col-5 pt-8">{{ item.winner }}</div>
              <div class="col-6 flex-center">
                <div class="ml-auto" v-if="item.checkLive">
                  <div class="mission-list-btn live">
                    {{ $t("happilyVillage.Live") }}
                  </div>
                </div>
                <div class="ml-auto" v-else-if="item.status === 'upcoming'">
                  <div class="mission-list-btn upcoming">
                    {{ $t("happilyVillage.Upcoming") }}
                  </div>
                </div>
                <div class="ml-auto" v-else-if="item.status === 'skip'">
                  <div class="mission-list-btn skip">
                    {{ $t("happilyVillage.Skip_Mission") }}
                  </div>
                </div>
                <el-tooltip effect="none" placement="bottom-end">
                  <div slot="content" class="relative">
                    <div class="hamburger-menu">
                      <div
                        v-if="item.status == 'skip'"
                        @click="unSkipMission(item)"
                        :class="`top`"
                      >
                        {{ $t("happilyVillage.Unskip_Mission") }}
                      </div>
                      <div
                        v-else
                        @click="skipMission(item)"
                        :class="`top${item.status == 'skip' ? ' disable' : ''}`"
                      >
                        {{ $t("happilyVillage.Skip_Mission") }}
                      </div>

                      <div
                        @click="editeMission(item, index)"
                        :class="`bottom${
                          item.type == 'happily' ? ' disable' : ''
                        }`"
                      >
                        {{ $t("happilyVillage.Edit") }}
                      </div>
                      <div
                        @click="deleteMission(item)"
                        :class="`bottom${
                          item.type == 'happily' ? ' disable' : ''
                        }`"
                      >
                        {{ $t("happilyVillage.Delete") }}
                      </div>
                    </div>
                  </div>
                  <img
                    src="../../assets/images/happilyvillage/ic_more@2x.png"
                    style="height: 20px"
                    class="show-menu"
                  />
                </el-tooltip>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <div class="remove-padding-modal">
      <el-dialog
        :visible.sync="createMissionModal"
        :before-close="closeDialogCreateMission"
        width="930px"
        top="8vh"
      >
        <div class="grid-2-sesstion">
          <div class="grid-left rm-scrollbar">
            <div class="header flex-center">
              <img
                :src="$utils('icons', 'ic_preview')"
                style="height: 24px; margin-top: -2px"
                class="mr-12"
              />
              <span>{{ $t("happilyVillage.Preview_on_Mobile") }}</span>
            </div>
            <div class="body px-40 py-32">
              <div
                class="ml-auto"
                style="height: 52px"
                v-if="createMissionForm.missionType"
              >
                <div class="right">
                  <img
                    v-if="createMissionForm.missionType"
                    :src="getImgPath(createMissionForm.missionType)"
                    style="height: 52px"
                  />
                </div>
              </div>
              <div v-else class="right">
                <div
                  class="bg-skeleton ml-auto"
                  style="width: 52px; height: 52px; border-radius: 52px"
                ></div>
              </div>
              <div
                v-if="
                  !$utils('watchingTrim', createMissionForm.names.en || '')
                "
                class="bg-skeleton height-12 mb-6"
                style="width: 75px"
              ></div>
              <div v-else class="fc-000000 fs-12 fw-500">
                {{ $t("happilyVillage.New_Mission") }}
              </div>
              <div
                v-if="
                  !$utils('watchingTrim', createMissionForm.names.en || '')
                "
                class="bg-skeleton height-16"
              ></div>
              <div v-else class="fc-404243 fs-14 fw-900 word-break">
                {{ createMissionForm.names.en.trim() }}
              </div>
              <div
                v-if="
                  !$utils('watchingTrim', createMissionForm.entryBonus || '')
                "
                class="flex mt-14"
              >
                <div
                  class="bg-skeleton height-20 mb-8"
                  style="width: 120px"
                ></div>
                <div
                  class="bg-skeleton height-16 ml-10 mt-2"
                  style="width: 16px; height: 16px; border-radius: 16px"
                ></div>
              </div>
              <div v-else class="flex fc-404243 fs-14 fw-500 mt-12">
                <div class="mr-6">
                  {{ $t("happilyVillage.Exntry_XP") }}: +{{
                    createMissionForm.entryBonus
                  }}
                </div>
                <div
                  style="
                    background-color: #6cffd5;
                    width: 8px;
                    height: 8px;
                    transform: rotate(45deg);
                    margin-top: 3px;
                  "
                ></div>
              </div>
              <div
                v-if="
                  !$utils(
                    'watchingTrim',
                    createMissionForm.descriptions.en || ''
                  )
                "
              >
                <div class="bg-skeleton height-20 mt-8"></div>
                <div class="bg-skeleton height-20 mt-6"></div>
                <div
                  class="bg-skeleton height-20 mt-6"
                  style="width: 70%"
                ></div>
              </div>
              <div v-else class="mt-12 pre-line word-break">
                {{ createMissionForm.descriptions.en }}
              </div>
              <div
                v-if="
                  $utils(
                    'watchingTrim',
                    createMissionForm.descriptions.en || ''
                  ) &&
                  $utils('watchingTrim', createMissionForm.descriptions.en || '')
                "
                class="fs-14 fw-700"
                style="letter-spacing: 1.25px"
              >
                <div
                  class="flex-mid mt-24"
                  style="
                    height: 50px;
                    background: #6200ee;
                    color: #ffffff;
                    border-radius: 4px;
                    box-shadow: 0px 4px 4px #00000040;
                  "
                >
                  {{ $t("happilyVillage.PLAY") }}
                </div>
                <div
                  class="flex-mid mt-12"
                  style="
                    height: 50px;
                    color: #adadad;
                    border: 1px solid #adadad;
                    border-radius: 4px;
                  "
                >
                  {{ $t("happilyVillage.VOTE") }}
                </div>
              </div>
              <div v-else>
                <div
                  class="bg-skeleton flex-mid mt-24"
                  style="height: 50px; border-radius: 4px"
                ></div>
                <div
                  class="bg-skeleton flex-mid mt-12"
                  style="height: 50px; border-radius: 4px"
                ></div>
              </div>
            </div>
          </div>
          <div class="grid-right">
            <form id="sessionModal" @submit.prevent="missionSubmit">
              <el-tabs v-model="missionFromLang">
                <el-tab-pane v-for="(val, index) in language"  :key="index"  :label="val.text" :name="val.text">

                  <div class="title mt-16">
                    {{ $t("happilyVillage.Name_of_Mission") }}
                  </div>
                  <el-input
                    :placeholder="$t('happilyVillage.Name_of_your_Mission')"
                    v-model="createMissionForm.names[val.code]"
                    class="name"
                    :class="{
                      'validate-input': validateMissionForm.names[val.code],
                    }"
                  ></el-input>
                  <div
                    v-if="validateMissionForm.names[val.code]"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Name") }}
                    </div>
                  </div>
                  <div class="title">
                    {{ $t("happilyVillage.Description") }}
                  </div>
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    :placeholder="$t('happilyVillage.A_sentence_or_two')"
                    v-model="createMissionForm.descriptions[val.code]"
                    :class="{
                      'validate-input': validateMissionForm.descriptions[val.code],
                    }"
                  ></el-input>
                  <div
                    v-if="validateMissionForm.descriptions[val.code]"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Mission_Type") }}
                    </div>
                  </div>




                </el-tab-pane>
                <!-- <el-tab-pane label="English" name="english">
                  <div class="title mt-16">
                    {{ $t("happilyVillage.Name_of_Mission") }}
                  </div>
                  <el-input
                    :placeholder="$t('happilyVillage.Name_of_your_Mission')"
                    v-model="createMissionForm.nameEnglish"
                    class="name"
                    :class="{
                      'validate-input': validateMissionForm.nameEnglish,
                    }"
                  ></el-input>
                  <div
                    v-if="validateMissionForm.nameEnglish"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Name") }}
                    </div>
                  </div>
                  <div class="title">
                    {{ $t("happilyVillage.Description") }}
                  </div>
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    :placeholder="$t('happilyVillage.A_sentence_or_two')"
                    v-model="createMissionForm.descriptionEnglish"
                    :class="{
                      'validate-input': validateMissionForm.descriptionEnglish,
                    }"
                  ></el-input>
                  <div
                    v-if="validateMissionForm.descriptionEnglish"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Mission_Type") }}
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Thai" v-if="!engonly" name="thai">
                  <div class="title mt-16">
                    {{ $t("happilyVillage.Name_of_Mission") }}
                  </div>
                  <el-input
                    :placeholder="$t('happilyVillage.Name_of_your_Mission_th')"
                    v-model="createMissionForm.nameThai"
                    class="name"
                    :class="{ 'validate-input': validateMissionForm.nameThai }"
                  ></el-input>
                  <div
                    v-if="validateMissionForm.nameThai"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Name") }}
                    </div>
                  </div>
                  <div class="title">
                    {{ $t("happilyVillage.Description") }}
                  </div>
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    :placeholder="$t('happilyVillage.A_sentence_or_two_th')"
                    v-model="createMissionForm.descriptionThai"
                    :class="{
                      'validate-input': validateMissionForm.descriptionThai,
                    }"
                  ></el-input>
                  <div
                    v-if="validateMissionForm.descriptionThai"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Mission_Type") }}
                    </div>
                  </div>
                </el-tab-pane> -->
              </el-tabs>
              <div class="grid-2-auto">
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Mission_Type") }}
                  </div>
                  <el-select
                    v-model="createMissionForm.missionType"
                    :placeholder="$t('happilyVillage.Select')"
                  >
                    <el-option
                      v-for="item in missionTypeOpt"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                  <div
                    v-if="validateMissionForm.missionType"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Mission_Type") }}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Entry_Bonus_XP") }}
                  </div>
                  <el-input
                    type="number"
                    placeholder="3"
                    v-model="createMissionForm.entryBonus"
                    class="validate-input"
                    :class="{
                      'validate-input': true,
                    }"
                  ></el-input>
                  <div
                    v-if="validateMissionForm.entryBonus"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Entry_Bonus") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="title">{{ $t("happilyVillage.Order") }}</div>
              <el-select
                v-model="createMissionForm.order"
                :placeholder="$t('happilyVillage.Select')"
                class="width-select"
              >
                <div v-if="missionUncomplete.length == 0&&!loadingChartStatus">
                  <el-option
                    :key="missionAll[missionAll.length-1].id"
                    :label="showLableNewSet(missionAll[missionAll.length-1])"
                    :value="missionAll[missionAll.length-1].id">
                  </el-option>
                </div>
                <div v-else>
                  <el-option
                  v-for="order in missionUncomplete"
                  :key="order.id"
                  :label="showLableNewSet(order)"
                  :value="order.id"
                  >
                  </el-option>
                </div>
                
              </el-select>
              <div v-if="validateMissionForm.order" class="validate-worming">
                <div class="text">
                  {{ $t("happilyVillage.Please_input_Order") }}
                </div>
              </div>
              <div class="title">{{ $t("happilyVillage.Status") }}</div>
              <el-select
                v-model="createMissionForm.status"
                :placeholder="$t('happilyVillage.Select')"
              >
                <el-option
                  v-for="item in statusOpt"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
                ></el-option>
              </el-select>
              <div v-if="validateMissionForm.status" class="validate-worming">
                <div class="text">
                  {{ $t("happilyVillage.Please_input_Status") }}
                </div>
              </div>

              <div class="flex mt-32" v-if="!createMissionForm.id">
                <el-button
                  class="btn-add bigger"
                  @click.prevent="missionSubmit"
                  >{{ $t("happilyVillage.CREATE_MISSION") }}</el-button
                >
                <el-button
                  class="btn-cancel bigger"
                  style="margin-left: 16px"
                  @click.prevent="closeDialogCreateMission"
                  >CANCEL</el-button
                >
              </div>
              <div class="flex mt-32" v-else>
                <el-button
                  class="btn-add bigger"
                  @click.prevent="saveChangesMission"
                  >{{ $t("happilyVillage.SAVE_MISSION") }}</el-button
                >
                <el-button
                  class="btn-cancel bigger"
                  style="margin-left: 16px"
                  @click.prevent="closeDialogCreateMission"
                  >CANCEL</el-button
                >
              </div>
            </form>
          </div>
        </div>
      </el-dialog>
    </div>
    
    <!-- Mission Details Modal -->
    <div class="remove-padding-modal">
      <el-dialog
        :visible.sync="missionDetailsModal"
        width="800px"
        top="8vh"
      >
        <div class="p-32">
          <div class="mission-details-header">
            <div class="flex-center">
              <img
                v-if="selectedMission.missionTypeIcon"
                :src="selectedMission.missionTypeIcon"
                style="height: 32px"
                class="mr-12"
              />
              <h2 class="fs-24 fw-700 fc-000000">{{ selectedMission.name }}</h2>
            </div>
            <div class="fs-16 white-space-pre-line">{{ selectedMission.description }}</div>
          </div>

          <div class="mission-details-stats mt-32">
            <div class="grid-2">
              <div class="stat-box">
                <div class="stat-label">{{ $t("happilyVillage.Entries") }}</div>
                <div class="stat-value">{{ $utils("addCommasInNumber", selectedMission.entries) }}</div>
              </div>
              <div class="stat-box">
                <div class="stat-label">{{ $t("happilyVillage.Winner") }} (House)</div>
                <div class="stat-value">
                  <div class="flex-center">
                    <img
                      v-if="selectedMission.winner === 'Delphinus'"
                      alt="Delphinus"
                      src="../../assets/images/happilyvillage/Delphinus_32@2x.png"
                      class="image-skeleton image-profile-32 mr-8"
                    />
                    <img
                      v-else-if="selectedMission.winner === 'Corvus'"
                      alt="Corvus"
                      src="../../assets/images/happilyvillage/Corvus_32@2x.png"
                      class="image-skeleton image-profile-32 mr-8"
                    />
                    <img
                      v-else-if="selectedMission.winner === 'Leonos'"
                      alt="Leonos"
                      src="../../assets/images/happilyvillage/Leonos_32@2x.png"
                      class="image-skeleton image-profile-32 mr-8"
                    />
                    {{ selectedMission.winner }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mission-details-participants mt-32">
            <h3 class="fs-18 fw-700 mb-16">{{ $t("happilyVillage.Participants") }}</h3>
            <div v-if="loadingParticipants" class="center">
              <loading-even></loading-even>
            </div>
            <div v-else class="participants-list">
              <div v-for="(participant, index) in sortedParticipants" :key="participant.id" class="participant-row">
                <div class="flex-center">
                  <div class="rank-number mr-12">{{ index + 1 }}</div>
                  <div class="avatar-container mr-12">
                    <div v-if="loadingParticipants || (!participant.pic && !participant.name)" class="avatar-skeleton"></div>
                    <img 
                      v-if="participant.pic || participant.name"
                      :src="participant.pic || getDefaultAvatar(participant.name)" 
                      class="avatar"
                      :class="{'image-skeleton': !participant.pic}"
                      alt="User avatar"
                    />
                  </div>
                  <div class="flex-grow">
                    <div class="fw-600">{{ participant.name }}</div>
                    <div class="fs-14 fc-626262">{{ participant.house }}</div>
                  </div>
                  <div class="points-display">
                    <span class="points-value">{{ participant.points || 0 }}</span>
                    <span class="points-label">pts</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import draggable from "vuedraggable";
import { truncateSync } from "fs";
import * as firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  name: "university",
  components: {
    draggable: draggable,
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  async created() {
    this.$store.dispatch("reward/checkEngOnly");
    await this.$store.dispatch("happilyvillageBattleStadium/getCompany");
    // await this.$store.dispatch("happilyvillageBattleStadium/getMisiionUser");
    await this.$store.dispatch(
      "happilyvillageBattleStadium/getMisiionType",
      this.user
    );
    this.$store.dispatch("happilyvillageBattleStadium/getMission");
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    missionList: {
      get() {
        return this.$store.getters["happilyvillageBattleStadium/mission"];
      },
      set(value) {
        this.$store.commit("happilyvillageBattleStadium/setMission", value);
      },
    },
    inputSearchMission: {
      get() {
        return this.$store.getters["happilyvillageBattleStadium/inputSearch"];
      },
      set(value) {
        this.$store.commit("happilyvillageBattleStadium/setinputSearch", {
          value,
        });
      },
    },
    loadingMissionList() {
      return this.$store.getters[
        "happilyvillageBattleStadium/loadingMissionList"
      ];
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    missionTypeOpt() {
      return this.$store.getters["happilyvillageBattleStadium/missionTypeOpt"];
    },
    missionChart() {
      return this.$store.getters["happilyvillageBattleStadium/missionChart"];
    },
    missionEntry() {
      return this.$store.getters["happilyvillageBattleStadium/missionEntry"];
    },
    countMissionAll() {
      return this.$store.getters["happilyvillageBattleStadium/countMissionAll"];
    },
    customList() {
      return this.$store.getters["happilyvillageBattleStadium/missionCustom"];
    },
    missionsComplete() {
      return this.$store.getters["happilyvillageBattleStadium/missionComplete"];
    },
    missionUncomplete: {
      get() {
        return this.$store.getters[
          "happilyvillageBattleStadium/missionUncomplete"
        ];
      },
      set(value) {
        this.$store.commit(
          "happilyvillageBattleStadium/setMissionUncomplete",
          value
        );
      },
    },
    missionTypeIcon() {
      return this.$store.getters["happilyvillageBattleStadium/missionTypeIcon"];
    },
    engonly() {
      return this.$store.getters["reward/engonly"];
    },
    missionAll() {
      return this.$store.getters["happilyvillageBattleStadium/missionAll"];
    },
    language() {
      return this.$store.getters["reward/language"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    sortedParticipants() {
      return [...this.missionParticipants].sort((a, b) => b.points - a.points);
    },
    missionPerUser(){
      return this.$store.getters["happilyvillageBattleStadium/missionperuser"];
    }
  },

  data() {
    return {
      statusMission:false,
      setBeforeEdit: {
        order: "",
      },
      loadingChartStatus: true,
      battle_stadium_bar_chart: null,
      sessionForm: {
        name: "",
        description: "",
        dateAndTime: "",
        duration: null,
        location: "",
        sessionLimit: null,
        price: null,
        topic: null,
        commentPermission: 1,
      },
      validateSessionForm: {
        name: false,
        description: false,
        dateAndTime: false,
        duration: false,
        location: false,
        sessionLimit: false,
        price: false,
        topic: false,
      },
      createMissionModal: false,
      orderOpt: [
        { name: "one", key: "id1" },
        { name: "two", key: "id2" },
        { name: "three", key: "id3" },
      ],
      statusOpt: [
        { name: "Upcoming", key: "upcoming" },
        { name: "Skip Mission", key: "skip" },
      ],
      createMissionForm: {
        name: null,
        description: null,
        missionType: null,
        names:{},
        descriptions:{},
        entryBonus: null,
        order: null,
        status: "upcoming",
      },
      missionFromLang: "English",
      validateMissionForm: {
        names:{},
        nameEnglish: false,
        nameThai: false,
        descriptions:{},
        descriptionEnglish: false,
        descriptionThai: false,
        missionType: false,
        entryBonus: false,
        order: false,
        status: false,
      },
      sortOptions: [
        {
          value: "show_all",
          label: "Status - Show All",
        },
        {
          value: "only_show_completed",
          label: "Status - Only Show Completed",
        },
        {
          value: "only_show_upcoming_and_skipped",
          label: "Status - Only Show Upcoming & Skipped",
        },
        {
          value: "only_show_upcoming",
          label: "Status - Only Show Upcoming",
        },
      ],
      sortingBy: "show_all",
      newSet: {
        setName: "",
        position: null,
        id: false,
        customSet: false,
        happilySet: null,
      },
      oldCurrentMoveMission: false,
      MoveMission: false,
      missionDetailsModal: false,
      selectedMission: {},
      missionParticipants: [],
      loadingParticipants: false,
    };
  },
  watch: {
    inputSearchMission() {
      this.$store.dispatch(
        "happilyvillageBattleStadium/searchMission",
        this.inputSearchMission
      );
    },
    missionChart() {
      if (this.battle_stadium_bar_chart) {
        this.battle_stadium_bar_chart.destroy();
      }
      this.randerBarChartMisstion();
    },
    language(){
      for(const i in this.language){
   
        
        if(!this.validateMissionForm.names[this.language[i].code]){
          this.validateMissionForm.names[this.language[i].code]=false
        }
        if(!this.validateMissionForm.descriptions[this.language[i].code]){
          this.validateMissionForm.descriptions[this.language[i].code]=false
        }
      }
    }
  },
  mounted() {
    if (this.battle_stadium_bar_chart) {
      this.battle_stadium_bar_chart.destroy();
    }
    this.randerBarChartMisstion();
  },
  methods: {
    randerBarChartMisstion() {
      var missionBarchart = this.$refs.missionBarchart;
      const months = [];
      const value = [];
      for (const x in this.missionChart) {
        months.push(this.missionChart[x].month);
        value.push(this.missionChart[x].value);
      }
      // Reverse the arrays to show oldest months first
      months.reverse();
      value.reverse();

      if (missionBarchart) {
        this.loadingChartStatus = false;
        const missionBarChartData = {
          labels: months,
          datasets: [
            {
              label: "University Chart",
              data: value,
              backgroundColor: "#EF115E46",
              borderColor: "#EF115E",
              borderWidth: 1,
              datalabels: {
                color: "#EF115E",
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins.tooltip = {
          enabled: false,
        };
        options.layout = {
          padding: {
            top: 36,
          },
        },
        this.battle_stadium_bar_chart = new Chart(
          missionBarchart.getContext("2d"),
          {
            plugins: [ChartDataLabels],
            type: "bar",
            data: missionBarChartData,
            options: options,
          }
        );
      }
    },
    onChangeSorting(event) {
      this.$store.commit("happilyvillageBattleStadium/setselectShow", {
        type: this.sortingBy,
      });
      this.$store.dispatch(
        "happilyvillageBattleStadium/selectStatus",
        this.sortingBy
      );
    },
    showLableNewSet(set) {
      let week = 0;
      if (set) {
        this.missionList.map((value, index) => {
          if (value.id == set.id) {
            week = index + 1;
            value.week = week;
          }
        });
        return "After week " + week;
      }
    },
    beforeNewSet(set) {
      let week = 0;
      if (set) {
        this.missionList.map((value, index) => {
          if (value.id == set.id) {
            week = index;
          }
        });
        if (week > 0) {
          return "After week " + week;
        } else {
          return "Before week " + week;
        }
      }
    },
    chooseRecipe(event, origin) {
      if (
        (event.draggedContext.element.status &&
          event.draggedContext.element.status === "completed") //||
        // (event.draggedContext.element.type &&
        //   event.draggedContext.element.type === "happily")
      ) {
        this.oldCurrentMoveMission = false;
        return false;
      } else {
        // console.log('event.draggedContext.index',event.draggedContext.index)
        // console.log('event.relatedContext.list',event.relatedContext.list)
        this.MoveMission = event.draggedContext.futureIndex;
        this.oldCurrentMoveMission =
          event.relatedContext.list[event.draggedContext.index + 1];
      }
    },
    async updateCradList(event) {
      const currentPosition = event.newIndex;
      const movedSet = this.missionList[currentPosition] || false;
      const beforeSet = this.missionList[currentPosition - 1] || false;
      // console.log(this.missionList)
      // console.log('currentPosition',currentPosition)
      // console.log('movedSet',movedSet.title_en,"==",movedSet.happilySet,"==",movedSet.customSet)
      // console.log('beforeSet',beforeSet.title_en,"==",beforeSet.happilySet,"==",beforeSet.customSet)
      // console.log('this.oldCurrentMoveMission',this.oldCurrentMoveMission.title_en,"==",this.oldCurrentMoveMission.happilySet,"==",this.oldCurrentMoveMission.customSet)
      this.missionUncomplete = _.filter(
        this.missionList,
        function (currentObject) {
          return currentObject.status != "completed";
        }
      );
      let firstSet=0
      let firstSatus=true
      let first_Set=0
      let first_Satus=true
      let count =0
      let happilySet = 0
      for(const i in this.missionList){
        if(happilySet!=this.missionList[i].happilySet){
          happilySet = this.missionList[i].happilySet
          count=0
        }
        if(
        this.missionList[i].happilySet==beforeSet.happilySet&&
        this.missionList[i].happilySet==movedSet.happilySet
        &&this.missionList[i].checkLive==false
        &&this.missionList[i].status!='completed'){
          if(firstSatus==true){
            firstSatus=false
            firstSet=this.missionList[i].customSet
          }
          this.missionList[i].customSet=firstSet
          firstSet++  
          await this.$store.dispatch(
                "happilyvillageBattleStadium/updatePositionMissionCustom",
                this.missionList[i]
          );
          // console.log('this.missionList[i].title_en',this.missionList[i].title_en)
          // console.log('this.missionList[i].customSet',this.missionList[i].customSet)



        }else if(this.missionList[i].happilySet==beforeSet.happilySet
        &&this.missionList[i].checkLive==false
        &&this.missionList[i].status!='completed'){
          count++
          this.missionList[i].customSet = count;
          if(beforeSet.title_en==this.missionList[i].title_en){
            const index = parseInt(i) + 1;
            this.missionList[index].happilySet = beforeSet.happilySet;
            this.missionList[index].customSet = count+1;
            await this.$store.dispatch(
                "happilyvillageBattleStadium/updatePositionMissionCustom",
                this.missionList[index]
          );
            // console.log('this.missionList[i+1].happilySet',this.missionList[index])
          }

        }
        if(this.missionList[i].happilySet==this.oldCurrentMoveMission.happilySet&&
          beforeSet.happilySet!=this.oldCurrentMoveMission.happilySet
      
          &&this.missionList[i].checkLive==false
          &&this.missionList[i].status!='completed'){
          if(first_Satus==true){
            first_Satus=false
            first_Set=this.missionList[i].customSet
          }
          this.missionList[i].customSet=first_Set
          first_Set++  
          await this.$store.dispatch(
                "happilyvillageBattleStadium/updatePositionMissionCustom",
                this.missionList[i]
          );
          // console.log('1111',this.missionList[i].title_en)
          // console.log('111',this.missionList[i].customSet)
        }

      }


      

    
      // if (
      //   this.oldCurrentMoveMission != undefined &&
      //   beforeSet.id != this.oldCurrentMoveMission.id
      // ) {
      //   await this.downPositionOfSet();
      // }
      // if (beforeSet.type && beforeSet.type == "happily") {
      //   let count=beforeSet.customSet
      //   for (let i = 0; i < this.customList.length; i++) {
      //     if (
      //       this.customList[i].happilySet == beforeSet.happilySet &&
      //       this.customList[i].id !== movedSet.id 
      //     ) {
      //       count++
      //       console.log('this.customList[i].customSet',this.customList[i].customSet)
      //       console.log('beforeSet.customSet',beforeSet.customSet)
      //       if(this.customList[i].customSet > beforeSet.customSet){
      //         this.customList[i].customSet = count ;
      //         if(beforeSet.title_en==this.customList[i].title_en){
      //         count++
      //         this.missionList[currentPosition].customSet = count+1;
      //         }
      //         console.log('1',this.customList[i].title_en,"==",this.customList[i].customSet)
      //         await this.$store.dispatch(
      //           "happilyvillageBattleStadium/updatePositionMissionCustom",
      //           this.customList[i]
      //         );
      //       }
      //     }
      //   }
      //   if(beforeSet.status_order==true){
      //     this.missionList[currentPosition].happilySet = beforeSet.happilySet;
      //   }else{
      //     this.missionList[currentPosition].customSet = 1;
      //     this.missionList[currentPosition].happilySet = beforeSet.happilySet;
      //   }
        
      // } else if (beforeSet.type && beforeSet.type == "custom") {
      //   let count=beforeSet.customSet
      //   for (let i = 0; i < this.customList.length; i++) {
      //     if (
      //       this.customList[i].happilySet == beforeSet.happilySet &&
      //       this.customList[i].customSet > beforeSet.customSet
      //     ) {
            
      //       this.customList[i].customSet = count+1;
      //       console.log('2',this.customList[i])
      //       await this.$store.dispatch(
      //         "happilyvillageBattleStadium/updatePositionMissionCustom",
      //         this.customList[i]
      //       );
      //     }
      //   }
      //   this.missionList[currentPosition].customSet = beforeSet.customSet + 1;
      //   this.missionList[currentPosition].happilySet = beforeSet.happilySet;
      // } else if (beforeSet == false) {
      //   for (let i = 0; i < this.customList.length; i++) {
      //     if (this.customList[i].happilySet == 0) {
      //       this.customList[i].customSet = this.customList[i].customSet + 1;
      //       console.log('3',this.customList[i])
      //       await this.$store.dispatch(
      //         "happilyvillageBattleStadium/updatePositionMissionCustom",
      //         this.customList[i]
      //       );
      //     }
      //   }
      //   this.missionList[currentPosition].customSet = 1;
      //   this.missionList[currentPosition].happilySet = 0;
      //   console.log('4', this.missionList[currentPosition])
      //   await this.$store.dispatch(
      //     "happilyvillageBattleStadium/updatePositionMissionCustom",
      //     this.missionList[currentPosition]
      //   );
      // }
      // console.log('6',  this.missionList[currentPosition].title_en,"==",this.missionList[currentPosition].customSet)
      // // await this.$store.dispatch(
      //   "happilyvillageBattleStadium/updatePositionMissionCustom",
      //   this.missionList[currentPosition]
      // );
    },
    async downPositionOfSet() {

      for (let i = 0; i < this.customList.length; i++) {
        // console.log('this.oldCurrentMoveMission.customSet',this.oldCurrentMoveMission.customSet)
        // console.log('this.customList[i].customSet',this.customList[i].customSet)
        if(this.customList[i].happilySet ==
            this.oldCurrentMoveMission.happilySet &&
          this.customList[i].customSet >= this.oldCurrentMoveMission.customSet){

        }
        else if (
          this.customList[i].happilySet ==
            this.oldCurrentMoveMission.happilySet &&
          this.customList[i].customSet >= this.oldCurrentMoveMission.customSet

        ) {
          this.customList[i].customSet = this.customList[i].customSet - 1;
          //console.log('5',this.customList[i].title_en,"==",this.customList[i].customSet)
          await this.$store.dispatch(
            "happilyvillageBattleStadium/updatePositionMissionCustom",
            this.customList[i]
          );
        }
      }
    },
    skipMission(item) {
      if (item.status && item.status == "upcoming") {
        this.$store.dispatch(
          "happilyvillageBattleStadium/blockMission",
          item.key
        );
      }
    },
    unSkipMission(item) {
      this.$store.dispatch(
        "happilyvillageBattleStadium/unblockMission",
        item.key
      );
    },
    editeMission(item) {
      // console.log('item',item)
      if (
        item.status &&
        item.status !== "completed" &&
        item.type != "happily"
      ) {
        let order;
        for (let index = 0; index < this.missionList.length; index++) {
          if (item.id === this.missionList[index].id) {
            if (this.missionList[index - 1].status === "completed") {
              order = "#beforeSetOne";
            } else {
              order = this.missionList[index - 1].id;
            }

          }
          
        }
        
        this.createMissionModal = true;
        this.setBeforeEdit.order = order;
        this.createMissionForm = {
          id: item.id,
          nameThai: item.title_th,
          nameEnglish: item.title_en,
          descriptionEnglish: item.description_en,
          descriptionThai: item.description_th,
          missionType: item.missionType,
          entryBonus: item.xp,
          order: order,
          happilySet: item.happilySet,
          customSet: item.customSet,
          status: item.status,
        };
        this.createMissionForm.names=item.titles
        this.createMissionForm.descriptions=item.descriptions
      }
    },
    deleteMission(item) {
      if (item.type && item.type == "custom") {
        const text = `This will delete '${item.name}' mission. Continue?`;
        this.$confirm(text, "Warning", {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        })
          .then(() => {
            for (let i = 0; i < this.customList.length; i++) {
              if (
                this.customList[i].happilySet == item.happilySet &&
                this.customList[i].customSet > item.customSet
              ) {
                this.customList[i].customSet = this.customList[i].customSet - 1;

                this.$store.dispatch(
                  "happilyvillageBattleStadium/updatePositionMissionCustom",
                  this.customList[i]
                );
              }
            }
            this.$store.dispatch(
              "happilyvillageBattleStadium/deleteMissionCustom",
              item
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Delete canceled",
            });
          });
      }
    },
    async missionSubmit() {
      let validate = await this.validateForm()
      if(!validate){
          const missioncomplete = _.filter(
          this.missionList,
          function (currentObject) {
            return currentObject.status == "completed";
          }
        );
        if (
          this.createMissionForm.order == "#beforeSetOne" &&
          missioncomplete.length == 0
        ) {
          this.createMissionForm.happilySet = 0;
          this.createMissionForm.customSet = 1;
          for (let i = 0; i < this.customList.length; i++) {
            if (this.customList[i].happilySet == 0) {
              this.customList[i].customSet = this.customList[i].customSet + 1;
              //console.log("22222", this.customList[i])
              await this.$store.dispatch(
                "happilyvillageBattleStadium/updatePositionMissionCustom",
                this.customList[i]
              );
            }
          }
        } else {
          if (this.createMissionForm.order == "#beforeSetOne") {
            this.createMissionForm.order =
              missioncomplete[missioncomplete.length - 1].id;
          }
          for (let i = 0; i < this.missionList.length; i++) {
            if (this.missionList[i].id == this.createMissionForm.order) {
              this.createMissionForm.happilySet =
                this.missionList[i].happilySet;
              this.createMissionForm.customSet =
                this.missionList[i].customSet + 1;
                //console.log("22ไไไ222", this.missionList[i])
              for (let i2 = 0; i2 < this.customList.length; i2++) {
                if (
                  this.customList[i2].happilySet ==
                    this.missionList[i].happilySet &&
                  this.customList[i2].customSet > this.missionList[i].customSet
                ) {
                  this.customList[i2].customSet =
                    this.customList[i2].customSet + 1;
                    ///console.log("22222", this.customList[i2])
                  await this.$store.dispatch(
                    
                    "happilyvillageBattleStadium/updatePositionMissionCustom",
                    this.customList[i2]
                  );
                }
              }
            }
          }
        }
        this.$store.dispatch(
          "happilyvillageBattleStadium/createMissionCustom",
          this.createMissionForm
        );
        this.createMissionModal = false;
        this.clearMissionFrom();

      }
    },
    validateForm(){

      let validate=false
      for(const index in this.language){
        if(!this.createMissionForm.names[this.language[index].code]){
          this.validateMissionForm.names[this.language[index].code]=true
          validate=true
        }else{
          this.validateMissionForm.names[this.language[index].code]=false
        }

        if(!this.createMissionForm.descriptions[this.language[index].code]){
          this.validateMissionForm.descriptions[this.language[index].code]=true
          validate=true
        }else{
          this.validateMissionForm.descriptions[this.language[index].code]=false
        }

      }
      if(!this.createMissionForm.missionType ){
           this.validateMissionForm.missionType=true
           validate=true
        }else{
          this.validateMissionForm.missionType=false
        }
        if(!this.createMissionForm.entryBonus ){
           this.validateMissionForm.entryBonus=true
           validate=true
        }else{
          this.validateMissionForm.entryBonus=false
        }
        if(!this.createMissionForm.order ){
           this.validateMissionForm.order=true
           validate=true
        }else{
          this.validateMissionForm.order=false
        }
        if(!this.createMissionForm.status ){
           this.validateMissionForm.status=true
           validate=true
        }else{
          this.validateMissionForm.status=false
        }
      return validate
    },
    async saveChangesMission() {
      let validate = await this.validateForm()

     
      if(!validate){
        if (this.createMissionForm.order !== this.setBeforeEdit.order) {
          for (let i = 0; i < this.customList.length; i++) {
            if (this.customList[i].id == this.createMissionForm.id) {
              this.oldCurrentMoveSet = {
                happilySet: this.customList[i].happilySet,
                customSet: this.customList[i].customSet,
              };
            }
          }
         // await this.downPositionOfSet();
          this.missionSubmit();
        } else {
          this.$store.dispatch(
            "happilyvillageBattleStadium/createMissionCustom",
            this.createMissionForm
          );
          this.createMissionModal = false;
          this.clearMissionFrom();
        }
      
        
      }
      
    },
    clearMissionFrom() {
      
      this.createMissionForm.name = null;
      this.createMissionForm.names={}
      this.createMissionForm.description = null;
      this.createMissionForm.descriptions={}
      this.createMissionForm.missionType = null;
      this.createMissionForm.entryBonus = null;
      this.createMissionForm.order = null;
      this.createMissionForm.nameThai = null;
      this.createMissionForm.nameEnglish = null;
      this.createMissionForm.descriptionEnglish = null;
      this.createMissionForm.id = null;
      this.createMissionForm.descriptionThai = null;
      this.createMissionForm.status = "upcoming";
      this.setBeforeEdit.order = null;
      this.missionFromLang = "English";
      this.validateMissionForm={
        names:{},
        descriptions:{},
        nameEnglish: false,
        nameThai: false,
        descriptionEnglish: false,
        descriptionThai: false,
        missionType: false,
        entryBonus: false,
        order: false,
        status: false,
      }
      for(const i in this.language){
    
        if(this.validateMissionForm.names&&!this.validateMissionForm.names[this.language[i].code]){
          this.validateMissionForm.names[this.language[i].code]=false
        }else{
          this.validateMissionForm.names[this.language[i].code]=false
        }
        if(this.validateMissionForm.descriptions&&!this.validateMissionForm.descriptions[this.language[i].code]){
          this.validateMissionForm.descriptions[this.language[i].code]=false
        }else{
          this.validateMissionForm.descriptions[this.language[i].code]=false
        }
        
      }
    },
    closeDialogCreateMission() {
      let value =
      this.createMissionForm.descriptions&&this.createMissionForm.descriptions.en &&this.createMissionForm.names
        this.createMissionForm.names.en;
      if (value) {
        this.$confirm("This will discard mission. Continue?", "Warning", {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        })
          .then(() => {
            this.clearMissionFrom();
            this.createMissionModal = false;
          })
          .catch(() => {
            this.createMissionModal = true;
          });
      } else {
        this.clearMissionFrom();
        this.createMissionModal = false;
      }
    },
    getImgPath(id) {
      return this.missionTypeIcon[id].icon;
    },
    showMissionDetails(mission) {
      // For completed missions, show details
      if (mission.status === 'completed') {
        this.selectedMission = mission;
        this.missionDetailsModal = true;
        this.loadMissionParticipants(mission.key);
      } 
      // For live or upcoming missions, show a notification
      else if (mission.status === 'upcoming' || mission.checkLive) {
        const status = mission.checkLive ? 'Live' : 'Upcoming';
        this.$message({
          message: `${status} mission details will be available after the mission has been completed.`,
          type: 'info',
          duration: 3000
        });
      }
    },

    async loadMissionParticipants(missionId) {
      this.loadingParticipants = true;
      try {
        // const missionsComplete = {};
        
        // // Get completed mission data to identify winner
        // await firebase.firestore()
        //   .collection('mission_complete')
        //   .where("company", "==", this.$store.state.authen.user.company)
        //   .where("mission_id", "==", missionId)
        //   .get()
        //   .then(querySnapshot => {
        //     querySnapshot.forEach(doc => {
        //       missionsComplete[doc.data().mission_id] = {
        //         id: doc.id,
        //         houses: doc.data().house[0],
        //         date: doc.data().createdate,
        //         winner_email: doc.data().winner_email,
        //         points: doc.data().points || {}
        //       };
        //     });
        //   });
        

        // Check if we have mission participant data
        if (this.missionPerUser && this.missionPerUser[missionId]) {
          const mission_PerUser = this.missionPerUser[missionId];
          
          // Only set winner info if we have completed mission data
          if (this.missionsComplete[missionId]) {
            mission_PerUser.isWinner = this.missionsComplete[missionId].winner_email;
          }
          
          this.missionParticipants = mission_PerUser;
        } else {
          this.missionParticipants = [];
        }
      } catch (error) {
        console.error("Error loading participants:", error);
        this.missionParticipants = [];
      } finally {
        this.loadingParticipants = false;
      }
    },

    getDefaultAvatar(name = '') {
      // Extract initials from the name
      const initials = name
        .split(' ')
        .map(part => part.charAt(0))
        .join('')
        .toUpperCase()
        .substring(0, 2) || 'U';
      
      // Create SVG for the avatar
      const backgroundColor = '5C21E0'; // Purple background
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
          <rect width="40" height="40" fill="#${backgroundColor}"/>
          <text x="50%" y="50%" dy=".1em" fill="white" font-family="Lato, sans-serif" 
                font-size="16" font-weight="normal" text-anchor="middle" dominant-baseline="middle">
            ${initials}
          </text>
        </svg>
      `;
      
      // Convert SVG to a data URL
      const dataUrl = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
      return dataUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-container {
  border-radius: 24px;
  background: rgba(0,0,0,0.03);
}
.btn-add.small {
  font-size: 14px;
  height: 33px;
  width: 160px;
}
.mission-list {
  background-color: #ffffff;
  box-shadow: 0 2px 4px #00000029;
  padding: 14px 10px 14px 20px;
  border-radius: 6px;
  margin-top: 12px;
  font-size: 14px;
  transition: 0.2s;
  &:hover {
    background-color: #f3f0f7;
  }

  .show-menu {
    opacity: 0;
    transition: 0.2s;
  }
  &:hover {
    .show-menu {
      opacity: 1;
    }
  }
}
.col-1 {
  width: 100px;
}
.col-2 {
  width: 420px;
}
.col-4 {
  width: 120px;
}
.col-5 {
  width: 80px;
}
.col-6 {
  width: 130px;
}
.mission-list-btn {
  border-radius: 6px;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 4px 12px;
}
.mission-list-btn.completed {
  cursor: default;
  background-color: #5c21e0;
}
.mission-list-btn.upcoming {
  background-color: #929094;
}
.mission-list-btn.live {
  cursor: default;
  background-color: #18b70b;
}
.mission-list-btn.skip {
  background-color: #f42a2a;
}
.grid-2-sesstion {
  display: grid;
  grid-template-columns: 400px auto;
}
.grid-left {
  .header {
    background-color: #6c30cc;
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    padding: 18px 40px;
  }
}
.grid-right {
  padding: 40px;
  background-color: #f8f8f8;
  padding-top: 55px;
}
.btn-cancel {
  background-color: #00000030;
  border-color: #00000030;
}
.bg-skeleton {
  background-color: #d8d8d8;
  border-radius: 3px;
  width: 100%;
}
.height-20 {
  height: 20px;
}
.height-16 {
  height: 16px;
}
.height-12 {
  height: 12px;
}
.mission-details-header {
  border-bottom: 1px solid #EAEAEA;
  padding-bottom: 24px;
  margin-bottom: 24px;
  
  h2 {
    margin: 0 0 12px 0;
  }
}

.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.stat-box {
  background: #F8F8F8;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
}

.stat-label {
  font-size: 14px;
  color: #626262;
  margin-bottom: 10px;
  font-weight: 600;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #000000;
}

.participants-list {
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.participant-row {
  padding: 14px 20px;
  border-bottom: 1px solid #EAEAEA;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #F8F8F8;
  }
  
  &:last-child {
    border-bottom: none;
  }
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-container {
  position: relative;
  width: 40px;
  height: 40px;
}

.avatar-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  animation: pulse 1.5s infinite ease-in-out;
  overflow: hidden;
}

.avatar-skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(200%);
  }
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}

.image-skeleton {
  background-color: transparent;
}

.winner-badge {
  background: #5C21E0;
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}

.rank-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #F0F0F0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: #404243;
}

.flex-grow {
  flex: 1;
}

.points-display {
  text-align: right;
  min-width: 60px;
}

.points-value {
  font-size: 16px;
  font-weight: 700;
  color: #5C21E0;
}

.points-label {
  font-size: 12px;
  color: #626262;
  margin-left: 2px;
}

.white-space-pre-line {
  white-space: pre-line;
  word-break: keep-all;
}

.details-icon {
  color: #5C21E0;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.2);
  }
}
</style>
